// Small controls the store-configuration pages share: a dollars input that
// speaks cents, and the error line.

import { useEffect, useState } from 'react';

const fmt = (c: number | null) => (c === null ? '' : (c / 100).toFixed(2));
const parse = (t: string): number | null => {
  if (t.trim() === '') return null;
  const n = Math.round(parseFloat(t) * 100);
  return Number.isFinite(n) && n >= 0 ? n : null;
};

/** A dollars text input over a nullable cents value — blank is null. The
 * `title` is the story hook (money inputs carry one). */
export function MoneyInput(props: {
  value: number | null;
  onChange: (cents: number | null) => void;
  title: string;
  placeholder?: string;
  disabled?: boolean;
}) {
  const [text, setText] = useState(fmt(props.value));
  // Re-sync when the owner's value changes out from under the text.
  useEffect(() => {
    if (parse(text) !== props.value) setText(fmt(props.value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value]);
  return (
    <input
      className="input money"
      inputMode="decimal"
      title={props.title}
      aria-label={props.title}
      placeholder={props.placeholder ?? '0.00'}
      disabled={props.disabled}
      value={text}
      onChange={(e) => {
        setText(e.target.value);
        props.onChange(parse(e.target.value));
      }}
      onBlur={() => setText(fmt(props.value))}
    />
  );
}

export function Err(props: { error: string | null }) {
  return props.error ? <div className="err" role="alert">{props.error}</div> : null;
}
